


<div class="modal-dialog">
    <div class="modal-body">
        <div class="form-group row">
            <div class="col-md-12">
                <p class="tituloModal">
                    ¿Deseas salir de la sala de espera?
                </p>
                <p class="subTituloModal">
                    Recuerda que una vez tu médico asignado inicie la video consulta seras ingresado automaticamente desde esta seccion. </p>
                    <p class="subTituloModal">Al salir tendras que volver a ingresar a la sala de espera para asi poder ser atendido</p>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button type="button" class="btn botonCancelar colorLetraVolver" [mat-dialog-close]="false">Cancelar</button>
        </div>
        <div class="col-md-6 letrabotonagregar">
            <button type="button" class="btn botonVolver" [mat-dialog-close]="true">Aceptar</button>
        </div>
    </div>
</div>